module.exports = "/client/static/images/browser-firefox.ece488b0.svg";